/** Website-only media. Enable writes/cutover only after the new rules are reviewed. */
export const WEBSITE_HERO_ROOT = 'website_hero';
export const WEBSITE_HERO_SOURCE_ENABLED = process.env.REACT_APP_WEBSITE_HERO_ENABLED === 'true';
export const WEBSITE_HERO_WRITES_ENABLED = process.env.REACT_APP_WEBSITE_HERO_WRITES_ENABLED === 'true';
export const WEBSITE_HERO_ADMIN_UID = process.env.REACT_APP_WEBSITE_HERO_ADMIN_UID || '';
export const WEBSITE_HERO_STORAGE_BUCKET = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '';
export const WEBSITE_HERO_MAX_BYTES = 5 * 1024 * 1024;
export const WEBSITE_HERO_MAX_DIMENSION = 4096;
export const WEBSITE_HERO_MAX_PIXELS = 16 * 1024 * 1024;
export const WEBSITE_HERO_DECODE_TIMEOUT = 10000;
